// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2029":"217f4828f1d82594","2888":"d8b5ad42f8fd2347"}[chunkId] + ".css";
};